import React, { useState } from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: ['inverse'],
  states: []
}

export default function Radio(props) {
  let {
    id,
    parentId,
    className,
    inverse,
    parentClassName,
    name,
    value,
    children,
    defaultChecked,
    currentValue = '',
    onClick,
    onChange,
    checked = false,
    parentProps,
    ...rest
  } = props

  const _input = React.useRef(null)

  if (checked) {
    currentValue = value
  }
  if (defaultChecked) {
    currentValue = value
  }

  // const initialState
  const handleKeyPress = (e) => {
    if (e.charCode === 32 || e.charCode === 13) {
      !!onChange && onChange(_input.current.value)
    }
  }

  const handleChange = (value) => {
    !!onChange && onChange(value)
  }

  return (
    <div
      {...parentProps}
      id={parentId}
      tabIndex={0}
      onClick={() => {
        return !!onChange && onChange(_input.current.value)
      }}
      onKeyPress={(e) => handleKeyPress(e)}
      htmlFor={id}
      className={
        resolveProps(props, config, 'Radio') + ' ' + (parentClassName || '')
      }
      aria-label="Radio button"
    >
      <input
        {...rest}
        className="mdn-Radio-input"
        type="radio"
        id={id}
        ref={_input}
        name={name || id}
        className={'mdn-Radio-input ' + (className || '')}
        onChange={() => handleChange(value)}
        checked={ currentValue === value }
        value={value}
        role="radio"
        aria-label="Radio button"
      />
      <label className="mdn-Radio-label" htmlFor={id} />
      <label className="mdn-Radio-text" htmlFor={id}>
        {children}
      </label>
    </div>
  )
}

Radio.propTypes = {
  parentId: PropTypes.string,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  config: PropTypes.object,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  defaultChecked: PropTypes.bool,
  currentValue: PropTypes.string,
  inverse: PropTypes.bool,
  parentProps: PropTypes.string
}
